import GavelOutlined from '@mui/icons-material/GavelOutlined';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

interface AiDisclaimerBlockProps {
  /** Short uppercase lead-in, e.g. "Assistenza IA". Optional: some surfaces
   * carry the transparency notice on its own, without a heading. */
  eyebrow?: string;
  body: string;
  /** Official source of the regulation cited in the body (EUR-Lex), as a real link. */
  source?: { href: string; label: string };
}

/**
 * The single rendering of the AI transparency notice (AI Act art. 50(2):
 * the user must be told, plainly, that what they are looking at was produced
 * with AI assistance and has to be checked). One component so the notice
 * cannot drift into three slightly different treatments across goods
 * receiving, the counter-label AI fill and any future call site — the text
 * itself stays in i18n, chosen by the caller.
 */
export function AiDisclaimerBlock({ eyebrow, body, source }: AiDisclaimerBlockProps) {
  return (
    <Alert
      severity="info"
      icon={<GavelOutlined fontSize="small" />}
      sx={{
        alignItems: 'flex-start',
        py: 0.75,
        '& .MuiAlert-message': { fontSize: '0.78rem', lineHeight: 1.45 },
      }}
    >
      {eyebrow && (
        <Typography
          component="span"
          sx={{
            display: 'block',
            fontWeight: 700,
            fontSize: '0.7rem',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            mb: 0.25,
          }}
        >
          {eyebrow}
        </Typography>
      )}
      {body}
      {source && (
        <Link
          href={source.href}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ display: 'block', mt: 0.5, minHeight: 24 }}
        >
          {source.label}
        </Link>
      )}
    </Alert>
  );
}
